import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "status"]
  static values = { url: String, pairId: Number, assignment: String }

  disconnect() {
    clearTimeout(this.noticeTimeout)
    clearTimeout(this.hideTimeout)
  }

  async change(event) {
    const previous = this.assignmentValue
    const designation = event.target.value

    this.clearNotice()
    this.selectTarget.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ affiliate_user_pair_id: this.pairIdValue, designation })
      })
      if (!response.ok) throw new Error("Unable to save GMS assignment")
      const result = await response.json()
      this.assignmentValue = result.designation
      this.selectTarget.value = result.designation
      this.showNotice("GMS assignment saved.", "success")
    } catch (error) {
      this.selectTarget.value = previous
      this.showNotice("Could not save GMS assignment. Please try again.", "danger")
    } finally {
      this.selectTarget.disabled = false
    }
  }

  showNotice(message, type) {
    clearTimeout(this.hideTimeout)
    this.statusTarget.classList.toggle("text-success", type === "success")
    this.statusTarget.classList.toggle("text-danger", type === "danger")
    this.statusTarget.textContent = message
    this.statusTarget.classList.add("is-visible")
    this.noticeTimeout = setTimeout(() => this.clearNotice(), type === "success" ? 4000 : 8000)
  }

  clearNotice() {
    clearTimeout(this.noticeTimeout)
    clearTimeout(this.hideTimeout)
    this.statusTarget.classList.remove("is-visible")
    this.hideTimeout = setTimeout(() => { this.statusTarget.textContent = "" }, 350)
  }
}
